import { useMemo } from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { CrmObjectRow } from './CrmObjectRow';
import type { FlexDataLink } from 'pages/flex-data/flex-data-links/types';
import { sortLinkedObjects } from '../utils';

interface CrmObjectsListProps {
  stagedObjects: FlexDataLink[];
  linkedObjects: FlexDataLink[];
  contentId: string;
  onRemoveStaged: (objectId: string) => void;
}

export function CrmObjectsList({ stagedObjects, linkedObjects, contentId, onRemoveStaged }: CrmObjectsListProps) {
  const { t } = useTranslation();
  const sortedLinked = useMemo(() => sortLinkedObjects(linkedObjects), [linkedObjects]);

  return (
    <Stack direction="column" gap={1}>
      <Typography variant="subtitle1Prominent">{t('editor.side_panel.link_crm_object_modal.linked_objects')}</Typography>
      {stagedObjects.length === 0 && linkedObjects.length === 0 ? (
        <Stack direction="column" alignItems="center" gap={2} sx={{ pb: 3 }}>
          <Stack direction="column" alignItems="center" gap={0.5}>
            <Typography variant="h6" align="center">
              {t('editor.side_panel.link_crm_object_modal.no_linked_objects')}
            </Typography>
            <Typography variant="body2" color="text.secondary" align="center">
              {t('editor.side_panel.link_crm_object_modal.no_linked_objects_description')}
            </Typography>
          </Stack>
        </Stack>
      ) : (
        <>
          {stagedObjects.map((obj) => (
            <CrmObjectRow key={obj.objectId} obj={obj} contentId={contentId} variant="staged" onRemoveStaged={onRemoveStaged} />
          ))}
          {sortedLinked.map((obj) => (
            <CrmObjectRow key={obj.objectId} obj={obj} contentId={contentId} variant="linked" />
          ))}
        </>
      )}
    </Stack>
  );
}
